import { GlobalState } from './state';
import { GlobalAction } from './actions';

export const globalReducer = (state: GlobalState, action: GlobalAction): GlobalState => {
  switch (action.type) {
    case 'SET_ISDARK':
      return { ...state, isDark: action.payload };
    case 'SET_ERROR':
      return { ...state, error: action.payload };
    case 'SET_TABS':
      return { ...state, tabs: action.payload };
    case 'SET_TAB': {
      return { ...state, tabs: [...state.tabs, action.payload] };
    }
    case 'SET_TABS_PAGE_MAP':
      return { ...state, tabsPageMap: action.payload };
    case 'SET_ACTIVE_TAB':
      return { ...state, activeTab: action.payload };
    case 'SET_STATE_VIDEO':
      return { ...state, stateVideo: action.payload };
    case 'SET_RELOAD_PROJECT_LIST':
      return { ...state, reloadProjectList: action.payload };
    default:
      return state;
  }
};
